import {AfterViewInit, Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";

@Component({
  selector: 'db-copilot-video',
  templateUrl: './copilot-video.component.html',
  standalone: true,
  styleUrls: ['./copilot-video.component.scss']
})
export class CopilotVideoComponent implements AfterViewInit {
  @ViewChild('aiBuilderVideo') aiBuilderVideo: ElementRef<HTMLVideoElement>;

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('modal-close-right')) {
      this.close();
    }
  }

  constructor(
    private _activeModal: DbActiveModal
  ) {}

  ngAfterViewInit() {
    this.playVideo();
  }

  public playVideo(): void {
    setTimeout(() => {
      if (this.aiBuilderVideo && this.aiBuilderVideo.nativeElement) {
        this.aiBuilderVideo.nativeElement.play();
      }
    }, 1000);
  }

  close() {
    this._activeModal.close();
  }
}
